export class TeamProjectAuthV2 {
  authJwt: string

  constructor(authJwt: string) {
    this.authJwt = authJwt
  }
}
